import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

const SELECTORS = {
    block: '.wp-block-ssm-post-preview',
    carousel: '.splide',
    arrows: '.splide__arrows',
};

const DEFAULT_OPTIONS = {
    direction: 'ttb',
    height: '25rem',
    wheel: false,
    pagination: false,
    grid: {
        rows: 2,
        cols: 1,
        gap: {
            row: '1.25rem',
        },
    },
    breakpoints: {
        640: {
            height: '20.25rem',
        },
    },
};

export const initPostPreview = (block, isEditor = false) => {
    const carousel = block.querySelector(SELECTORS.carousel);

    // Skip if already initialized
    if (!carousel || carousel.splide) {
        return null;
    }

    let spl = Splide;
    let splGrid = Grid;

    if (isEditor) {
        const topDoc = window.top?.document;
        const iframe = topDoc?.querySelector('iframe[name="editor-canvas"]');
        const iWin = iframe?.contentWindow;

        if (iWin) {
            spl = iWin.Splide;
            splGrid = iWin.splide.Extensions.Grid;
        }
    }

    try {
        const splide = new spl(carousel, {
            ...DEFAULT_OPTIONS,
            ...(isEditor ? { drag: false, wheel: false } : {}),
        });

        let isOverflow = false;

        splide.on('mounted', function () {
            try {
                const Components = splide.Components;
                isOverflow = Components.Layout.isOverflow();

                const arrows = block.querySelector(SELECTORS.arrows);

                splide.on('resized', function () {
                    isOverflow = Components.Layout.isOverflow();
                    if (arrows) {
                        arrows.style.display = isOverflow ? '' : 'none';
                    }
                });
            } catch (error) {
                console.error('Error setting up Post Preview carousel controls:', error);
            }
        });

        splide.mount({ Grid: splGrid });

        return () => {
            if (splide && typeof splide.destroy === 'function') {
                splide.destroy();
            }

            delete carousel.splide;
        };
    } catch (error) {
        console.error('Error initializing Post Preview carousel:', error, carousel);

        return null;
    }
};

export const PostPreview = () => {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initPostPreview(block);
    });
};
